module.exports = "/_next/static/images/b1b2d046a92ab3cff0b317e03b33aa91-card-and-phone-3d-xs@2x.jpg.webp";